import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const CheckoutRegisterFormFormValidationSchema = yup.object({
    guestEmail: RHFUserValidationRules.emailWithNB
});

export type CheckoutRegisterFormFormValues = yup.InferType<
    typeof CheckoutRegisterFormFormValidationSchema
>;
